function Footer() {
    return(
        <div>
            <div className='site-footer hidden-xs hidden-sm'>
                <div className='footer-column'>
                    <h4>
                    The Turn Around Recovery House<br/><br/>
                    <p>Luxury Recovery Housing • Restore Hearts • Renew Hope • Rise Together</p>
                    © 2026 The Turn Around Recovery House. All rights reserved.
                    </h4>
                </div>
                <div className='footer-column'>
                    {/* <h4>Call Now: <span style={{textDecoration:"underline"}}>(123) 456-7890</span></h4> */}
                    <h4>Email: <span style={{textDecoration:"underline"}}>info@turnaroundrecoveryfoundation.org</span></h4>
                    {/* <h4>Follow Us: <a className='footer-link' href="https://facebook.com">Facebook</a> | <a className='footer-link' href="https://instagram.com">Instagram</a></h4> */}
                </div>
            </div>

            <div className='site-footer visible-xs visible-sm'>
                <h4>The Turn Around Recovery House</h4>
                © 2026 The Turn Around Recovery House. All rights reserved.
                <p>Luxury Recovery Housing • Restore Hearts • Renew Hope • Rise Together</p>
                {/* <h5>Call Now: <span style={{textDecoration:"underline"}}>(123) 456-7890</span></h5> */}
                <h5>Email: <span style={{textDecoration:"underline"}}>info@turnaroundrecoveryfoundation.org</span></h5>
                {/* <h5>Follow Us: <a className='footer-link' href="https://facebook.com">Facebook</a> | <a className='footer-link' href="https://instagram.com">Instagram</a></h5> */}
            </div>
        </div>
    )
}

export default Footer;